console.log('decoy-sturcture.js');

let decoySelectors = document.querySelectorAll('.js-decoy');
let subSelecotr = document.querySelector('.js-sub-selector');
decoySelectors.forEach((decoySelector) => {
    decoySelector.addEventListener('click', (e) => {
        decoySelectors.forEach(decoySelector => decoySelector.classList.remove('active'));
        e.preventDefault();
        // let jsSelectPlan = document.querySelector('.js-select-plan');
        // jsSelectPlan.name = 'selling_plan_inactive';
        let planId = decoySelector.getAttribute('data-selling-plan');
        console.log('planId: ', planId);
        e.target.classList.add('active');
        //subSelecotr.classList.remove('rc-option--active');
        let productId = decoySelector.getAttribute('data-product-id');
        let productPrice = decoySelector.getAttribute('data-regular-price');
        let newPrice = decoySelector.getAttribute('data-price');
        let priceDivs = document.querySelectorAll('.price-item--regular');
        let priceDivsNew = document.querySelectorAll('.js-new-price');
        priceDivsNew.forEach((priceDiv) => {
            priceDiv.innerHTML = newPrice;
        });
        priceDivs.forEach((priceDiv) => {
            priceDiv.innerHTML = productPrice;
        });
        let inputId = document.querySelector('.product-variant-id');
        let sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        sellingPlanInput.value = planId;
        inputId.value = productId;
        console.log('productPrice: ', productPrice);
    });
});
// subSelecotr.addEventListener('click', (e) => {
//     e.preventDefault();
//     if(e.target.classList.contains('rc_widget__option__selector')) {
//         e.target.parentNode.classList.add('rc-option--active');
//     } else {
//         e.target.classList.add('rc-option--active');
//     }
//     let productOriginal = document.querySelector('.product-original')
//     decoySelectors.forEach(decoySelector => decoySelector.classList.remove('active'));
//     productOriginal.classList.add('active');
//     let productId = productOriginal.getAttribute('data-product-id');
//     let productPrice = productOriginal.getAttribute('data-price');
//     let inputId = document.querySelector('.product-variant-id');
//     let jsSelectPlan = document.querySelector('.js-select-plan');
//     jsSelectPlan.name = 'selling_plan';
//     inputId.value = productId;
//     priceDivs.forEach((priceDiv) => {
//         priceDiv.innerHTML = productPrice;
//     });
// });